import { Alert, Button, Modal, Table } from "antd"
import { formatDateTimeISO } from "../../../../utils/date";
import { useGetUsimInventoryUploadJobsQuery } from "../../../../api/usim/inventory/usimInventoryApi";
import { UsimInventoryUploadJob } from "../../../../api/usim/inventory/usimInventoryUploadJobs";

const columns = [
  {
    title: "Job ID",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Processed Started At",
    dataIndex: "UpdatedAt",
    key: "UpdatedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-",
    sorter: (a: UsimInventoryUploadJob, b: UsimInventoryUploadJob) => a.ProcessedStartedAt.localeCompare(b.ProcessedStartedAt)
  },
  {
    title: "Processed Finished At",
    dataIndex: "ProcessedFinishedAt",
    key: "ProcessedFinishedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-",
    sorter: (a: UsimInventoryUploadJob, b: UsimInventoryUploadJob) => a.ProcessedFinishedAt.localeCompare(b.ProcessedFinishedAt)
  },
  {
    title: "Row Count (if successful)",
    dataIndex: "IngestedRows",
    key: "IngestedRows"
  },
  {
    title: "Error Count",
    dataIndex: "ErrorRows",
    key: "ErrorRows",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
  },
  {
    title: "Action",
    key: "action",
    render: (_: any, obj: UsimInventoryUploadJob) => {
      function onClickViewErr() {
        Modal.confirm({
          content: obj.Errors!!.map(err => <li>{err}</li>),
          width: 800
        })
      }
      return (
        <Button
          disabled={obj.Errors == null}
          onClick={onClickViewErr}
        >
          View Errors
        </Button>
      )
    }
  }

]

export default function UploadJobTable() {
  const { data, error, isFetching, refetch } = useGetUsimInventoryUploadJobsQuery();

  // Sort data by ProcessedFinishedAt in descending order (latest first)
  const sData = data?.toSorted((a, b) =>
    b.ProcessedFinishedAt.localeCompare(a.ProcessedFinishedAt));

  return (
    <>
    <Button onClick={refetch} type="primary">Reload</Button>
    { error && <Alert type="error" message="Error loading data" /> }
    <Table
      loading={isFetching}
      dataSource={sData}
      columns={columns}
    />
    </>
  )
}
